import { Button, Modal, Tooltip, message } from "antd";
import { StopOutlined } from "@ant-design/icons";
import useAxios from "../../hooks/useAxios";

const CancelSubmissionButton = ({
  cancelUrl,
  disabled,
  disabledReason,
  onCancelled,
}) => {
  const { fetchData, loading } = useAxios();

  const handleClick = () => {
    Modal.confirm({
      title: "Cancel this submission?",
      content:
        "This will mark the submission as cancelled. It cannot be undone.",
      okText: "Cancel Submission",
      okButtonProps: { danger: true },
      cancelText: "Back",
      onOk: () =>
        fetchData({ url: cancelUrl, method: "POST" })
          .then(() => {
            message.success("Submission cancelled.");
            onCancelled?.();
          })
          .catch((error) => {
            const msg =
              error?.response?.data?.message ||
              "Failed to cancel submission.";
            message.error(msg);
          }),
    });
  };

  return (
    <Tooltip title={disabled ? disabledReason : "Cancel this submission"}>
      <Button
        type="primary"
        danger
        shape="circle"
        icon={<StopOutlined />}
        disabled={disabled}
        loading={loading}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default CancelSubmissionButton;
